import { Pipe, PipeTransform } from '@angular/core';
import { CompanyOrderStatus } from '@tmx/data-access';

@Pipe({
  name: 'status',
  standalone: true,
})
export class StatusPipe implements PipeTransform {
  transform(value: CompanyOrderStatus) {
    switch (value) {
      case 'Complete':
        return 'Completed';
      case 'Failed':
        return 'Failed';
      case 'Pending':
        return 'In Progress';
      default:
        return 'Unknown';
    }
  }
}
